// extracted by mini-css-extract-plugin
export default {"Benefit":"Benefit_Benefit__yrHgM","tittle":"Benefit_tittle__nHgl5","text":"Benefit_text__38Wc+"};